export const DangerZoneSection = {
  if: (el) => el.sdk.hasPermission('iam'),
  CardContent: {
    flow: 'y',
    align: 'start',
    gap: 'C1',
    Hgrpup: {
      H: {
        color: 'title',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        text: 'Delete Project',
      },
      P: {
        margin: '0',
        text: 'Once you delete a project, there is no going back. Please be certain.',
      },
    },
    ContinueButton: {
      padding: 'Z2 C1',
      text: 'Delete Project',
      theme: null,
      border: '2px solid red.35',
      onClick: async (ev, el, st) => {
          // Double confirmation is not recommended because it can be frustrating for users.
          if (
            !window.confirm(
              `Are you sure you want to delete this project? This action cannot be undone.`
            )
          ) {
            return
          }

          if (
            !window.confirm(
              `Please confirm once more that you want to permanently delete "${st.projectName}".`
            )
          ) {
            return
          }

          const {
            projectId
          } = st

          try {
            await el.sdk.removeProject(projectId) // removeProject does not return anything
            el.call('openNotification', {
              title: 'Success message',
              message: 'The project has been successfully removed.',
              type: 'success'
            })
            setTimeout(() => {
              // SPA-nav to /dashboard after project removal. If the router
              // ever fails to apply the new route, fall back to a full
              // navigation so the user isn't stranded on the now-deleted
              // project's settings page.
              try {
                el.router('/dashboard', el.getRoot())
              } catch (_) {
                if (typeof window !== 'undefined') window.location.href = '/dashboard'
              }
            }, 1000)
          } catch (error) {
            el.call('openNotification', {
              title: 'Error message',
              message: `Error: ${error.message || 'Failed to delete project.'}`,
              type: 'error'
            })
          }
        },
    },
  },
  flow: 'x',
  width: '100%',
  maxWidth: 'I2',
  gap: 'B1',
  align: 'flex-start',
  position: 'relative',
  flow: 'y',
  margin: 'C1 0',
};